import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const MobileTabs = ({
  kpis,
  trustMeter,
  dashboardInsights,
  dictamen,
  inventario,
  registros,
  registroManual,
  produccion,
  configuracion,
  idioma
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('reportes');

  const tabs = [
    { id: 'reportes', icon: '📊', labelEs: 'Reportes', labelEn: 'Reports' },
    { id: 'registros', icon: '✍️', labelEs: 'Registros', labelEn: 'Records' },
    { id: 'produccion', icon: '🏭', labelEs: 'Producción', labelEn: 'Production' },
    { id: 'alertas', icon: '🔔', labelEs: 'Alertas', labelEn: 'Alerts' },
    { id: 'config', icon: '⚙️', labelEs: 'Config', labelEn: 'Config' }
  ];

  const getTabLabel = (tab) => {
    return idioma === 'es' ? tab.labelEs : tab.labelEn;
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100%', 
      minHeight: '100vh',
      paddingBottom: '70px'
    }}>
      {/* Contenido de la pestaña activa */}
      <div style={{ flex: 1, padding: '0 8px' }}>
        
        {/* PESTAÑA REPORTES */}
        {activeTab === 'reportes' && (
          <div style={{ display: 'block', width: '100%' }}>
            {/* ✅ KPIS - Renderizado forzado con depuración */}
            <div style={{ 
              display: 'block', 
              width: '100%', 
              marginBottom: '20px',
              backgroundColor: 'transparent'
            }}>
              {kpis ? (
                <div style={{ width: '100%' }}>
                  {kpis}
                </div>
              ) : (
                <div style={{
                  backgroundColor: '#7f1d1d',
                  border: '1px solid #ef4444',
                  borderRadius: '12px',
                  padding: '16px',
                  textAlign: 'center',
                  color: '#fca5a5',
                  fontSize: '14px'
                }}>
                  ⚠️ Error: KPIs no disponibles. Recarga la página o contacta soporte.
                </div>
              )}
            </div>
            
            {/* Trust Meter */}
            <div style={{ marginBottom: '20px' }}>
              {trustMeter}
            </div>
            
            {/* Inventario */}
            <div style={{ marginBottom: '20px' }}>
              {inventario}
            </div>
            
            {/* Registros */}
            <div style={{ marginBottom: '20px' }}>
              {registros}
            </div>
          </div>
        )}

        {/* PESTAÑA REGISTROS MANUALES */}
        {activeTab === 'registros' && (
          <div style={{ marginBottom: '20px' }}>
            {registroManual}
          </div>
        )}

        {/* PESTAÑA PRODUCCIÓN */}
        {activeTab === 'produccion' && (
          <div style={{ marginBottom: '20px' }}>
            {produccion}
          </div>
        )}

        {/* PESTAÑA ALERTAS */}
        {activeTab === 'alertas' && (
          <div>
            <div style={{ marginBottom: '20px' }}>
              {dashboardInsights}
            </div>
            <div style={{ marginBottom: '20px' }}>
              {dictamen}
            </div>
          </div>
        )}

        {/* PESTAÑA CONFIGURACIÓN */}
        {activeTab === 'config' && (
          <div style={{ marginBottom: '20px' }}>
            {configuracion}
          </div>
        )}
      </div>

      {/* Barra de navegación inferior - MODIFICADA: reducida y desplazada a la izquierda */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: 'calc(100% - 80px)', // Reduce el ancho total dejando 80px libres a la derecha
        marginRight: 'auto',        // Desplaza la barra hacia la izquierda
        backgroundColor: '#0f172a',
        borderTop: '1px solid #1e293b',
        borderRight: '1px solid #1e293b', // Borde derecho para estética
        borderTopRightRadius: '12px',     // Bordes redondeados en la esquina
        borderBottomRightRadius: '12px',
        display: 'flex',
        justifyContent: 'space-around',
        padding: '8px 12px',
        zIndex: 50,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)' // Sombra para destacar
      }}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              background: activeTab === tab.id ? '#1e293b' : 'transparent',
              border: 'none',
              padding: '8px 4px',
              borderRadius: '12px',
              transition: 'all 0.2s',
              color: activeTab === tab.id ? '#06b6d4' : '#64748b',
              cursor: 'pointer'
            }}
          >
            <span style={{ fontSize: '24px' }}>{tab.icon}</span>
            <span style={{ fontSize: '10px', fontWeight: 500 }}>{getTabLabel(tab)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileTabs;

